import { useEffect } from 'react';

const WIDGET_CONTAINER_SELECTOR = '#atlassian-conversation-assistant-widget';
const CHAT_WIDGET_LOADER_SCRIPT_URL =
	process.env['NODE_ENV'] === 'production'
		? 'https://jcs-chat-widget.atlassian.com/assets/loader.js'
		: 'https://jcs-chat-widget.stg.atlassian.com/assets/loader.js';
const CHAT_WIDGET_SCRIPT_ID = 'ai-chat-widget-loader';

export const AIChatWidget = () => {
	useEffect(() => {
		// Add SSR guards
		if (typeof window === 'undefined' || typeof document === 'undefined') {
			return;
		}

		const loadScript = (url: string) => {
			const script = document.createElement('script');
			script.src = url;
			script.defer = true;
			script.id = CHAT_WIDGET_SCRIPT_ID;
			document.body.append(script);
		};

		const checkAndLoadWidget = () => {
			try {
				const widget = document.querySelector(WIDGET_CONTAINER_SELECTOR);

				const existingScript = document.querySelector<HTMLScriptElement>(
					`script[src="${CHAT_WIDGET_LOADER_SCRIPT_URL}"], script#${CHAT_WIDGET_SCRIPT_ID}`,
				);

				if (!widget && !existingScript) {
					loadScript(CHAT_WIDGET_LOADER_SCRIPT_URL);
				}
			} catch (error) {
				console.error('Error checking and loading widget', error);
			}
		};

		checkAndLoadWidget();
	}, []);

	return null;
};
